module.exports = __webpack_public_path__ + "public/images/slider/nedbay-circle.b8373a3eb56b1c351999e62041ffb72c.png";